<app-language-selector></app-language-selector>

<router-outlet></router-outlet>
